import { createSlice } from "@reduxjs/toolkit";

// Define initial state for the slice.
const initialState = {
  data: [],
  loading: false,
  error: null,
  distribution: {},
  receipts: { error: null, loading: false, data: [] },
  storeQuantityError: [],
  provinces: { error: null, loading: false, data: [] },
  items: { error: null, loading: false, data: [] },
  exportStatus: { loading: false, error: null },
  drafts: { error: null, loading: false, data: [] },
  draftLoading: false,
};

//  Define slice and it's reducer functions.
const provinceOutSlice = createSlice({
  name: "provinceOut",
  initialState,
  reducers: {
    setData(state, action) {
      state.data = action.payload;
    },
    setLoading(state, action) {
      state.loading = action.payload;
    },
    setError(state, action) {
      state.error = action.payload;
    },
    setProvinceOut(state, action) {
      state.distribution = action.payload;
    },
    setProvinces(state, action) {
      state.provinces = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setItems(state, action) {
      state.items = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setProvinceOutReceipts(state, action) {
      state.receipts = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setStoreQuantityError(state, action) {
      state.storeQuantityError = action.payload;
    },
    setExportStatus(state, action) {
      state.exportStatus = {
        loading: action.payload.loading,
        error: action.payload.error,
      };
    },
    resetState(state) {
      state.data = [];
      state.loading = false;
      state.error = null;
      state.distribution = {};
      state.receipts = { error: null, loading: false, data: [] };
      state.storeQuantityError = [];
    },
    resetStoreQuantityError(state) {
      state.storeQuantityError = [];
    },
    resetProvinces(state) {
      state.provinces = { error: null, loading: false, data: [] };
    },
    resetItems(state) {
      state.items = { error: null, loading: false, data: [] };
    },
    resetReceipts(state) {
      state.receipts = { error: null, loading: false, data: [] };
    },
    resetExportStatus(state) {
      state.exportStatus = { loading: false, error: null };
    },
    setDrafts(state, action) {
      state.drafts = {
        error: action.payload.error,
        loading: action.payload.loading,
        data: action.payload.data,
      };
    },
    setDraftLoading(state, action) {
      state.draftLoading = action.payload;
    },
    addDraft(state, action) {
      if (state.drafts.data) {
        state.drafts.data.push(action.payload);
      } else {
        state.drafts.data = [action.payload];
      }
    },
    updateDraft(state, action) {
      const index = state.drafts.data.findIndex(
        draft => draft.id === action.payload.id
      );
      if (index !== -1) {
        state.drafts.data[index] = action.payload;
      }
    },
    removeDraft(state, action) {
      state.drafts.data = state.drafts.data.filter(
        draft => draft.id !== action.payload
      );
    },
    resetDrafts(state) {
      state.drafts = { error: null, loading: false, data: [] };
    },
  },
});

export const provinceOutAction = provinceOutSlice.actions;

export default provinceOutSlice;
